import { INgCustomDropdownOption } from '../../dropdowns/custom-dropdown/custom-dropdown.interface';
import { INgDatePickerOptions } from './date-picker.interface';


export function createMonthOptions(): INgCustomDropdownOption<number>[] {
	const monthFormatter: Intl.DateTimeFormat = new Intl.DateTimeFormat([], { month: 'short' });
	const monthOptions: INgCustomDropdownOption<number>[] = [];
	for (let month: number = 1; month <= 12; month++) {
		monthOptions.push({
			label: monthFormatter.format(new Date(2020, month - 1, 1)),
			value: month
		});
	}
	return monthOptions;
}

export function createYearOptions(options?: INgDatePickerOptions): INgCustomDropdownOption<number>[] {
	const currentYear: number = new Date().getFullYear();
	const minYear: number = options?.minDate?.getFullYear() ?? currentYear - 10;
	const maxYear: number = options?.maxDate?.getFullYear() ?? currentYear + 10;

	const yearOptions: INgCustomDropdownOption<number>[] = [];
	for (let year: number = minYear; year <= maxYear; year++) {
		yearOptions.push({ label: `${year}`, value: year });
	}
	return yearOptions;
}
